/**
 * MODULE: _shared/frontend-shell/src/pages/dashboard/useBodyScrollLock.ts
 * PURPOSE: Prevent background page scroll while dashboard overlays (filter drawer, KPI drill-down) are open
 * DEPENDENCIES: react (useEffect)
 * PUBLIC API: useBodyScrollLock
 * SIDE_EFFECTS: document.body.style.overflow; module-level lock ref for nested overlays
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: ~45/100
 */

import { useEffect } from 'react';

let _scrollLockCount = 0;

/**
 * When `locked` is true, increments a global lock and sets body overflow hidden.
 * Multiple concurrent locks (e.g. future stacked modals) are supported; last unlock restores scroll.
 */
export function useBodyScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    _scrollLockCount += 1;
    if (_scrollLockCount === 1) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      _scrollLockCount = Math.max(0, _scrollLockCount - 1);
      if (_scrollLockCount === 0) {
        document.body.style.overflow = '';
      }
    };
  }, [locked]);
}
